import styled, { css } from 'styled-components';
import { lightBaseTheme as lightBaseThemeWithLegacy } from '../theme/index.js';

const SectionHeadWrapper = styled.div.withConfig({
    displayName: "styles__SectionHeadWrapper",
    componentId: "sc-bf95baa2-0"
})`
    display: flex;
    height: 24px;
`;
const StyledSectionHead = styled.div.withConfig({
    displayName: "styles__StyledSectionHead",
    componentId: "sc-bf95baa2-1"
})`
    ${(props)=>css(props.theme.typography.SmallCapsHeadline)}
    color: ${(props)=>props.theme.colors["Level 5"]};
    flex: 1;
    display: flex;
    align-items: center;

    &::after {
        background-color: ${(props)=>props.theme.colors["Level 1"]};
        content: '';
        height: 4px;
        flex: 1;
        border-radius: 2px;
        margin-left: ${(props)=>props.theme.spacers.M};
    }
`;
StyledSectionHead.defaultProps = {
    theme: lightBaseThemeWithLegacy
};
const IconContainer = styled("span").withConfig({
    displayName: "styles__IconContainer",
    componentId: "sc-bf95baa2-2"
})`
    margin-right: 4px;
    color: ${(props)=>props.theme.colors["Level 5"]};
`;
IconContainer.defaultProps = {
    theme: lightBaseThemeWithLegacy
};

export { IconContainer, SectionHeadWrapper, StyledSectionHead };
